import '../utils/KeyboardEventsUtil';
import { ResolutionHandler } from '../utils/ResolutionHandler';
import { detect } from 'detect-browser';
import 'jquery-jcreate';

export default class Controller {

  constructor() {}

  /**
   * Components that will be always initialized in every controller
   * @returns {string[]}
   * @constructor
   **/
  static get BASE_COMPONENTS() {
    let components =  [
      'HistoryManagerComponent',
      'ModalComponent',
      'LoaderComponent',
      //'NewsletterPopupComponent',
      //'TestEmitBtnJUSTDEMO', //Just for DEMO
      'FormValidationComponent',
      //'DisabledLabelsComponent',
      'DataLinkHrefComponent',
      'LoginComponent',
      'LoginPopupComponent',
      'LoginFormComponent',
      'FidelityPopupComponent',
      'CarouselComponent',
      'PrivacyComponent',
      'AnimateComponent',
      //'ChangePasswordComponent',
      //'ShowPasswordComponent',
      //'SizeGuideLayerComponent',
      //'SizeTableSwitcherComponent',
      //'FormConditionalStepsComponent',
      //'SizeRowComponent', //Size row with slick
      'WishlistTogglerComponent', //TODO move to html or controller
      'ConfirmEnableComponent', //TODO move to html or controller
      //'VideoBrightcoveComponent',
      'TrackingComponent',
      'PrivacyPreference',
      'RecommendationEngineComponent',
      'PreventDoubleClick',
      'ChatComponent',
      'ShortcutPromoComponent'
    ];
    // return all the components
    return components;
  }

  setBrowserAttributes(obj) {
    return new Promise((resolve, reject) => {
      try {
        for (let key of Object.keys(obj)) {
          document.documentElement.setAttribute(`data-browser-${key}`, obj[key]);
        }
        resolve(true);
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Log utility
   * @param logStr
   */
  log(logStr = '') {
    if (logStr != '') {
      let myName = this.constructor.name;
      console.debug(`[${myName}] ${logStr}`);
    }
  }

  /*
   *  Initialization logic of the page
   */
  init() {
    this.log('Initializing..');

    if (detect())
      this.setBrowserAttributes(detect()).then(res => {
        console.debug('Browser data saved');
      });

    ResolutionHandler();

    try {
      let componentsToRender = [];
      // Dynamic init of components to be loaded
      this.loadedComponents = [];

      $(document).on('create', '[data-componentpb]', {ctx: this}, function(event) {
        let componentsToRender = this.getAttribute('data-componentpb');
        componentsToRender = componentsToRender.split(' ');
        if(componentsToRender == null || componentsToRender == '') return false;
        for (let component of componentsToRender) {
          if (event.data.ctx.loadedComponents.indexOf(component) === -1) {
            event.data.ctx.loadedComponents.push(component);
            event.data.ctx.log(`I can load "${component}" component`);
            import(/* webpackChunkName: `components-[request]` */ `../components/${component}`)
              .then(module => {
                let DynamicComponent = module.default; // we except that the component is the the default attribute of the module
                let dynamicComponent = new DynamicComponent();
                dynamicComponent.render();
              })
              .catch(error => {
                console.error('Failed to load the component', error.stack);
              });
          }
        }
      });
      // Dynamic init of components related to a controller
      componentsToRender = [...new Set(Controller.BASE_COMPONENTS.concat(this.constructor.COMPONENTS))];
      this.log(`Rendering: ${componentsToRender}`);
      for (let component of componentsToRender) {
        if (this.loadedComponents.indexOf(component) === -1) {
          this.loadedComponents.push(component);
          this.log(`I can load "${component}" component`);
          import(/* webpackChunkName: `components-[request]` */ `../components/${component}`)
            .then(module => {
              let DynamicComponent = module.default; // we except that the component is the the default attribute of the module
              let dynamicComponent = new DynamicComponent();
              dynamicComponent.render();
            })
            .catch(error => {
              console.error('Failed to load the component', error.stack);
            });
        }
      }
    } catch (error) {
      console.error('Failed to iterate over controller\'s components', error.stack);
    }
  }
}
